import { render, staticRenderFns } from "./TeamPage2.vue?vue&type=template&id=7d9d3fff&scoped=true"
import script from "./TeamPage2.vue?vue&type=script&lang=js"
export * from "./TeamPage2.vue?vue&type=script&lang=js"
import style0 from "./TeamPage2.vue?vue&type=style&index=0&id=7d9d3fff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9d3fff",
  null
  
)

export default component.exports